export default __webpack_public_path__ + "static/dateEnding-c859d0a4f713006fbd13371e1e701db4.svg";